export default {
  today: 'today',
  yesterday: 'yesterday',
  week: 'week',
  mouth: 'mouth',
  year: 'year',
  period: 'period'
}



// WEBPACK FOOTER //
// ./src/constants/periodNames.js